import React from 'react'
import PropTypes from 'prop-types'
import { useContentGetter } from 'layers/content/v2/hooks/useContentGetter'

export default function ContentDataGetter(Component, options = {}) {
  const { entryId, dynamicEntryId, queryType, locale, isPreview } = options

  function ComponentWithDataGetter(props) {
    // Support dynamic entryId from options while maintaining backwards compatibility
    // If dynamicEntryId is provided in options, use it; otherwise fall back to the static entryId
    const resolvedEntryId = dynamicEntryId || entryId

    const content = useContentGetter({
      entryId: resolvedEntryId,
      queryType,
      locale,
      isPreview,
    })

    return <Component {...props} content={content} />
  }

  ComponentWithDataGetter.propTypes = {
    content: PropTypes.object,
    fetchContent: PropTypes.func.isRequired,
    isFetching: PropTypes.bool,
    userContext: PropTypes.object,
  }

  return ComponentWithDataGetter
}
